/**
 * Display formatters for PIE.
 *
 * The math layer keeps all C/M/PE/ROE values in 0–1.0 (better for
 * arithmetic, better for the LLM). Humans read percentages. These
 * helpers do that translation in one place.
 */

/** Format a 0–1.0 value as an integer percentage. */
export function pct(value, { digits = 0, fallback = '—' } = {}) {
  if (value === null || value === undefined || Number.isNaN(value)) return fallback;
  return `${(Number(value) * 100).toFixed(digits)}%`;
}

/** Format a 0–100 value as an integer percentage. */
export function pct100(value, { digits = 0, fallback = '—' } = {}) {
  if (value === null || value === undefined || Number.isNaN(value)) return fallback;
  return `${Number(value).toFixed(digits)}%`;
}

/** Format a 0–1.0 *delta* in percentage-points. ΔPE 0.025 → "+2.5 pts". */
export function pp(value, { digits = 1, signed = true, fallback = '—' } = {}) {
  if (value === null || value === undefined || Number.isNaN(value)) return fallback;
  const v = Number(value) * 100;
  const sign = signed && v >= 0 ? '+' : '';
  return `${sign}${v.toFixed(digits)} pts`;
}

/** Format a 0–1.0 value as a percent without the trailing %, useful for chip rows. */
export function pctNum(value, { digits = 0, fallback = '—' } = {}) {
  if (value === null || value === undefined || Number.isNaN(value)) return fallback;
  return `${(Number(value) * 100).toFixed(digits)}`;
}
